export default "__VITE_ASSET__CW2Gq2N1__"